import { useTranslation } from 'react-i18next';
import styles from './CoBrandDetails.module.scss';
import { AuthBranding } from '@/components/Providers/BrandingProvider/BrandingProvider';

interface ICoBrandDetails {
  projectCoBranding: AuthBranding;
}

export const CoBrandDetails = ({
  projectCoBranding,
}: ICoBrandDetails): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.companyDetails}>
      <h1 className={styles.companyName}>{projectCoBranding.companyName}</h1>
      {projectCoBranding.name && (
        <h1 className={styles.name}>{t(projectCoBranding.name)}</h1>
      )}
    </div>
  );
};
